import { format } from 'date-fns';

const formatDay = (date: Date) => format(date, 'dd-LL-yyyy');

export default formatDay;
